import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
const accountRecoveryEmailVerificationSchema = z.object({
    accessToken: z.string(),
});
export class AccountRecoveryEmailVerificationResponseDto extends createZodDto(accountRecoveryEmailVerificationSchema) {
}
